// extracted by mini-css-extract-plugin
module.exports = {"rules":"styles_rules__1zuit","more":"styles_more__SPF4A"};